import { VantivAccount } from '../admin/store';

export class VantivAccountViewModel {
    public tenantId: number = 0;
    public enterpriseId: number = 0;
    public storeId: number = 0;
}

export class VantivAccountListViewModel extends VantivAccountViewModel {
    public accounts: VantivAccount[] = [];
}

export class VantivAccountAddOrUpdateViewModel extends VantivAccountViewModel {
    public account: VantivAccount = {};
    public type: string = '';
}
